import type { ImportPreProjectsInput, UpdateCityInput } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'
import type { PreProjectCityResponse } from '../queries/preProjects.queries'

export const importPreProjects = async (data: ImportPreProjectsInput) => {
  const response = await gozokiApiWithAuth.post<{
    created: number
    reactivated: number
    softDeleted: number
    total: number
  }>('/pre-projects/import', data)
  return response.data
}

export const updatePreProjectCount = async ({
  id,
  openingsCount,
}: {
  id: number
  openingsCount: number
}) => {
  const response = await gozokiApiWithAuth.patch(`/pre-projects/${id}`, { openingsCount })
  return response.data
}

export const deleteCity = async (id: number) => {
  const response = await gozokiApiWithAuth.delete(`/cities/${id}`)
  return response.data
}

export const updateCity = async ({ id, data }: { id: number; data: UpdateCityInput }) => {
  const response = await gozokiApiWithAuth.patch<PreProjectCityResponse>(`/cities/${id}`, data)
  return response.data
}
